import "./canvasextensions";
import guiFactory from "./gui";
import inputControllerFactory from "./inputcontroller";
import gameControllerFactory from "./../src/gamecontroller";
import initialStory from "./story/initial";
import godCommand from "./commands/god";
import worldFactory from "./world";
import nodes from "./story/nodes"

const gameState = {
}

const defaultError = {
    execute(gameState) {
        return [{
            lines: ["Syntax error."],
            startAt: 300
        }];
    }
};

const initialError = {
    execute(gameState) {
        return [{
            lines: ["Syntax error."],
            startAt: 300
        }];
    }
};

let commands = {
    error: defaultError
};

Object.assign(commands, godCommand);

gameState.commands = commands;
gameState.defaultError = defaultError;
gameState.nodes = nodes;

const commandFactory = {
        create: (command) => {
            return commands[command] || commands.error
        }
    };

let terminalCanvas = document.createElement("canvas"),
    terminalContext = terminalCanvas.getContext("2d"),
    start = Date.now(),
    inputController = inputControllerFactory(window, 40),
    gameController = gameControllerFactory(inputController, start, commandFactory, gameState),
    gui = guiFactory(terminalContext, start, inputController),
    world = worldFactory(terminalCanvas, nodes);

function draw() {
    gameController.tick(Date.now() - start);
    if (gameState.nextStory) {
        gameController.startStory(gameState.nextStory);

        gameState.nextStory = null;
    }

    gui.drawGui(gameController.outputHistory(), !inputController.inputEnabled());
    world.update();
    world.render();

    requestAnimationFrame(draw);
}

function targetReached() {
    gameController.startStory(currentNode.story, Date.now());
    currentNode.terminalVisible = true;
}

let currentNode = nodes["home"];

function init() {
    gameController.init(start);
    gameState.currentNode = "home";

    gui.drawGui(gameController.outputHistory(), !inputController.inputEnabled());
    world.init();
    gameController.startStory(initialStory, Date.now());

    world.register(x => {
        if (currentNode !== x.data && x.data.found) {
            gameState.currentNode = x.data.key;
            if (currentNode) {
                currentNode.terminalVisible = false;
            }
            
            currentNode = x.data;
            world.moveTo(currentNode, targetReached);
            inputController.disable();
            gameController.clearHistory();
        }
    });


    requestAnimationFrame(draw);
}

init();